import React from 'react';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { PMS_URL, FRONTEND_ADMIN_URL } from '../../config';

class UserMenu extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleClickTrigger = this.handleClickTrigger.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      menuOpen: false
    };
  }
  render() {
    const hide = !this.state.menuOpen ? 'hide' : '';
    const currentUser = this.props.api.getState('auth').currentUser || {};
    return (
      <li className="dropdown user user-menu">
        <a href="#" className="dropdown-toggle" onClick={ this.handleClickTrigger }>
          <i className="fas fa-user fa-fw"></i>
          <span className="hidden-xs">{ currentUser.name }</span>
        </a>
        <ul className={ 'dropdown-menu ' + hide }>
          <li className="header">{ currentUser.name }</li>
          <li>
            <ul className="menu">
              <li className="separator" onClick={ this.handleLogout }>
                <div><i className="fas fa-sign-out text-danger fa-fw"></i> Logout</div>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    );
  }
  toggle(menuOpen) {
    this.setState({ menuOpen });
  }
  handleClickTrigger(event) {
    event.preventDefault();
    const menuOpen = !this.state.menuOpen;
    this.toggle(menuOpen);
  }
  handleClickOutside() {
    this.toggle(false);
  }
  handleLogout() {
    const root = PMS_URL === '/' ? '' : PMS_URL;
    const currentUser = this.props.api.getState('auth').currentUser;
    const loginUrl = currentUser._is_pms_admin
      ? `${FRONTEND_ADMIN_URL}/login`
      : `${root}/login`;
    this.props.api.auth.logout()
      .then(() => this.props.router.push(loginUrl));
  }
}

export default UserMenu;



// WEBPACK FOOTER //
// ./src/frontend/layout/UserMenu.jsx